export const PROFILES = 'profiles' as const
